import { Box, Button, Link, Typography, useTheme } from '@mui/material';

const NextGenOutOfHours = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '800px',
        margin: '0 auto',
      }}
    >
      <Typography variant="h5" sx={{ mb: 3, color: theme.palette.text.primary }}>
        You've reached the end of your NextGen Tutoring hours — but your learning journey doesn't
        have to stop here!
      </Typography>

      <Button variant="contained" color="primary" sx={{ mb: 3, fontWeight: 'bold' }}>
        <Link
          href="https://app.hubspot.com/payments/cJVtXGmnhCZmxnh?referrer=PAYMENT_LINK"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: 'inherit', textDecoration: 'none' }}
        >
          Click here to purchase more hours
        </Link>
      </Button>

      <Typography variant="body1" sx={{ mb: 3, color: theme.palette.text.secondary }}>
        Stuck on which package to pick? We're here to help!{' '}
        <Link
          href="https://support.alpha.school"
          color="primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here
        </Link>{' '}
        to talk to our team.
      </Typography>

      <Typography variant="body1" sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}>
        Every hour you invest is a step closer to your goals. Let's keep learning! 🚀
      </Typography>
    </Box>
  );
};

export default NextGenOutOfHours;
